import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=989a56bc&scoped=true&"
import script from "./Program.vue?vue&type=script&lang=js&"
export * from "./Program.vue?vue&type=script&lang=js&"
import style0 from "./Program.vue?vue&type=style&index=0&id=989a56bc&prod&lang=css&"
import style1 from "./Program.vue?vue&type=style&index=1&id=989a56bc&prod&scoped=true&lang=css&"
import style2 from "./Program.vue?vue&type=style&index=2&id=989a56bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989a56bc",
  null
  
)

export default component.exports